<div class="d-flex flex-column">
  <div class="d-flex">
        <input-date [(value)]="date.day" (result)="emitChange()">
        </input-date>
        <div class="d-flex align-items-center">
            <span class="ml-3 mr-3">Giờ :</span>
            <div style="width: 75px;">
                <input-number [(amount)]="date.hour" (result)="emitChange()" [isInteger]="true" [isSeparate]="false" [maxLength]="2">
                </input-number>
            </div>
        
            <span class="ml-3 mr-3">phút :</span>
            <div style="width: 75px;">
                <input-number [(amount)]="date.minute" (result)="emitChange()" [isInteger]="true" [isSeparate]="false" [maxLength]="2">
                </input-number>
            </div>
        </div>
  </div>
  <div class="d-flex">
      <app-error-text [isDisplay]="date.hour && !checkHour()" 
          [message]="'Giờ không đúng định dạng.'">
      </app-error-text>
      <app-error-text [isDisplay]="date.minute && !checkMinute()" 
          [message]="'Phút không đúng định dạng.'">
      </app-error-text>
  </div>
</div>